import * as React from 'react';
import { CenterModal } from 'components';
import COLOR from 'constants/color';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

interface Props {
  form: {
    delivery_date?: Date;
    broadcast_preference?: string;
  };
  hasNoSquad?: boolean;
  onFormChange: (fieldName: string, value: string | Date) => void;
  vesselForm?: React.ReactNode;
}

const GeneralInfoForm = (props: Props): JSX.Element => {
  if (!(props.form && props.form.delivery_date)) {
    props.onFormChange('delivery_date', new Date());
  }
  const [showNoSquadModal, setNoSquadModal] = React.useState(false);
  const history = useHistory();

  return (
    <Card>
      {props.vesselForm ? (
        <VesselFormContainer>{props.vesselForm}</VesselFormContainer>
      ) : (
        false
      )}
      {showNoSquadModal && (
        <CenterModal
          leftButtonOnClick={(): void => {
            setNoSquadModal(false);
          }}
          leftButtonText="Back"
          rightButtonStyle="encourage"
          rightButtonType="secondary"
          rightButtonOnClick={(): void => {
            history.push('/setting/company/squad');
          }}
          rightButtonText="Invite member"
          title="You have no squad member yet"
        >
          Add your squad member or select another service.
        </CenterModal>
      )}
    </Card>
  );
};

export default GeneralInfoForm;

const Card = styled.div`
  border-radius: 0.5rem;
  border: 1px solid ${COLOR.neutral};
  background-color: ${COLOR.white};
  padding: 1.875rem 2.125rem;
  margin-bottom: 1.75rem;
`;

const VesselFormContainer = styled.section`
  margin-bottom: 1rem;
`;